import { QueryFeature } from '../../../../../../config/queryClient';

enum QueryKey {
  AssetBucketingResults = 'AssetBucketingResults',
  NetWorth = 'NetWorth',
}

export const queryKeys = {
  AssetBucketing: (clientId: number, fpId: string, year?: number) => [
    QueryFeature.AssetBucketingResults,
    QueryKey.AssetBucketingResults,
    clientId,
    fpId,
    ...(year ? [year] : []),
  ],
  netWorth: (clientId: string) => [QueryFeature.AssetBucketingResults, QueryKey.NetWorth, clientId],
};
